'use strict';

angular.module("PrintixInfoPrintJob", [])

  .constant("PrintixPrintJobInfoConstants", {
    SHOW: "print_job_info_show",
    HIDE: "print_job_info_hide"
  })

  .constant("PrintixPrintJobInfoSelectors", {
    MODAL_ID: "infoPrintJobModal",
    CONFIRM_BUTTON_CSS_CLASS: "confirm-button"
  })

  .controller("InfoPrintJobController",
    ["$rootScope", "$scope", "$location", "URLS", "PrintixPrintJobInfoConstants", "PrintixPrintJobInfoSelectors",
      function ($rootScope, $scope, $location, URLS, PrintixPrintJobInfoConstants,
                PrintixPrintJobInfoSelectors) {

        $scope.printJob = null;
        $scope.printJobInfoModalId = PrintixPrintJobInfoSelectors.MODAL_ID;

        $scope.clearPrintJobInfo = function () {
          if ($scope.printJob) {
            $scope.printJob = null;
          }
        };

        var locationChangeListener = function(){};
        $scope.showPrintJobInfo = function (printJob) {
          if (printJob) {
            $scope.printJob = printJob;
            var printJobModal = angular.element("#" + $scope.printJobInfoModalId);
            printJobModal.modal("show");
            locationChangeListener = $rootScope.$on('$locationChangeStart', function() {
              printJobModal?.modal("hide");
            })
          } else {
            throw "$scope.showPrintJobInfo: printJob is missing";
          }
        };

        var SHOW_listener = $rootScope.$on(PrintixPrintJobInfoConstants.SHOW, function (name, printJob) {
          $scope.showPrintJobInfo(printJob);
        });

        $scope.$on("$destroy", function () {
          SHOW_listener();
          locationChangeListener();
        });
      }
    ])

  .directive("infoPrintJobObjectControl", ["$rootScope", "PrintixPrintJobInfoSelectors", "PrintixPrintJobInfoConstants",
    function ($rootScope, PrintixPrintJobInfoSelectors, PrintixPrintJobInfoConstants) {
      return {
        link: function ($scope, element, attrs) {
          element.on("hide.bs.modal", function () {
            $scope.clearPrintJobInfo(angular.element(document.activeElement).hasClass(PrintixPrintJobInfoSelectors.CONFIRM_BUTTON_CSS_CLASS));
          });
          var HIDE_listener = $rootScope.$on(PrintixPrintJobInfoConstants.HIDE, function () {
            element.modal("hide");
          });

          $scope.$on("$destroy", function () {
            HIDE_listener();
          });
        }
      };
    }]);
